module.exports = __webpack_public_path__ + "fcf59722805fd1332c8237cfce4eee66.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/Sec-2/icon_3-sec2.svg
// module id = ./app/containers/StaticPage/ComeBack/assets/Sec-2/icon_3-sec2.svg
// module chunks = 40